module.exports = __webpack_public_path__ + "img/30.7ddc7529.png";